import * as React from 'react';
import * as intl from 'react-intl-universal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getRoles } from 'pc-sales/store/actions/user';

import { Link } from 'react-router-dom';
import ImageCropper from 'common/components/AvatarEditor';
import Image from 'common/components/Image';

interface iProps {
    className?: string;
    lastName?: string;
    firstName?: string;
    roleName?: string;
    style?: Object;
    link?: string;
    uhead: any;
    size?: 'large' | 'middle' | 'small';
    showUser?: boolean;
    crop?: boolean;
    onSubmit?: Function;
}

export default class Avatar extends React.Component<iProps> {
    static defaultProps = {
        showUser: true,
        size: 'small',
        crop: false // 是否支持头像裁剪
    };

    /**
     * 获取显示头像
     * @returns {any}
     */
    getAvatar = () => {
        const { crop, onSubmit, uhead, style, size } = this.props;
        return crop ?
            <ImageCropper url={uhead} onSubmit={onSubmit}>
                <Image className={`Avatar Avatar-${size}`} url={uhead} style={style}
                       fallbackUrl={window.config.img_file(`/images/icons/avatar.png`)}/>
            </ImageCropper> :
            <Image className={`Avatar Avatar-${size}`} url={uhead} style={style}
                   fallbackUrl={window.config.img_file(`/images/icons/avatar.png`)}/>;
    };

    /**
     * 基础组件
     * @returns {any}
     * @constructor
     */
    AvatarRender = () => {
        const { lastName, firstName, roleName, className, showUser } = this.props;
        return (
            <span className={className}>
                {this.getAvatar()}
                {showUser && <span key='user' className="User">
                    <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <span className="User-name">{intl.get('Global.Name', { firstName, lastName })}</span>
                        <span className="User-role">{roleName}</span>
                    </span>
                </span>}
            </span>
        );
    };

    render() {
        const { link } = this.props;
        return !!link ? (
            <Link to={link}>
                {this.AvatarRender()}
            </Link>
        ) : this.AvatarRender();
    }
}

const mapStateToProps = (state: any) => {
    return ({
        user: state.user.get('status'),
        roleMap: state.user.get('roles')
    });
};

const mapDispatchToProps = (dispatch: any) => ({
    ...bindActionCreators({
        getRoles: getRoles.init
    }, dispatch)
});

@(connect(mapStateToProps, mapDispatchToProps) as any)
export class MyAvatar extends React.Component<any> {
    componentDidMount() {
        const { roleMap, getRoles } = this.props;
        !roleMap && getRoles();
    }

    render() {
        const { roleMap, user, size, showUser, onSubmit, crop, link } = this.props;
        return (
            <Avatar {...{
                link: link,
                size: size,
                showUser: showUser,
                onSubmit: onSubmit,
                crop: crop,
                uhead: (user.uhead || {}),
                lastName: user.lastname,
                firstName: user.firstname,
                roleName: roleMap.get(user.uroleid)
            }} style={{
                marginBottom: '0.2rem',
            }}/>
        );
    }
}
